import axios from 'axios';
import Vue from 'vue';
import { Modal, Spin } from 'view-design';
import { getStorage, STORAGE_KEYS } from '@/utils/localStorage';

let vm = new Vue();

const addErrorLog = errorInfo => {
    const { statusText, status, request: { responseURL } } = errorInfo;
    let info = {
        type: 'ajax',
        code: status,
        mes: statusText,
        url: responseURL
    };
};

class HttpRequest {
    constructor(baseUrl = baseURL, fileServerUrl = fileServerURL) {
        this.baseUrl = baseUrl;
        this.fileServerUrl = fileServerUrl;
        this.queue = {};
    }
    getBaseUrl() {
        return this.baseUrl;
    }
    getFileServerUrl() {
        return this.fileServerUrl;
    }
    getInsideConfig() {
        const config = {
            baseURL: this.baseUrl,
            headers: {
                //
            }
        };
        return config;
    }
    destroy(url) {
        delete this.queue[url];
        if (!Object.keys(this.queue).length) {
            // Spin.hide()
        }
    }
    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(config => {
            let token = vm.getLoginCookieLoginToken();
            if (config.data instanceof FormData) {
                config.data.append('token', token);
            }
            else {
                config.data = {
                    ...config.data,
                    token: token || ''
                };
            }

            // 添加用户UUID和用户名
            const userId1 = getStorage(STORAGE_KEYS.USER_UUID) || vm.getLoginCookieUuid() || '';
            const userCode1 = getStorage(STORAGE_KEYS.USER_NAME) || vm.getLoginCookieName() || '';

            if (config.data instanceof FormData) {
                config.data.append('userId1', userId1);
                config.data.append('userCode1', userCode1);
            }
            else {
                config.data = {
                    ...config.data,
                    userId1,
                    userCode1
                };
            }

            // 添加全局的loading...
            if (!Object.keys(this.queue).length) {
                // Spin.show() // 不建议开启，因为界面不友好
            }
            this.queue[url] = true;
            return config;
        }, error => {
            return Promise.reject(error);
        });
        // 响应拦截
        instance.interceptors.response.use(res => {
            let response = res.data;

            
            if (response.code !== 0) {
                if (response.code === 100000) {
                    Modal.error({
                        title: '操作失败',
                        content: response.message,
                        closable: false
                    });
                }
                else if (response.code === 100001) {
                    Modal.error({
                        title: '操作失败',
                        content: response.message,
                        closable: false
                    });
                    vm.clearLoginCookies();
                    location.reload();
                }
                else {
                    Modal.error({
                        title: '操作失败',
                        content: response.message,
                        closable: false
                    });
                }
            }
            this.destroy(url);
            // const { data, status } = res;
            return res.data;
            // return { data : res.data, status : res.status };
        }, error => {
                Modal.error({
                    title: '操作失败',
                    content: '全局接口访问失败（请检查接口情况）',
                    closable: false
                });
            this.destroy(url);
            let errorInfo = error.response;
            if (!errorInfo) {
                const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error));
                errorInfo = {
                    statusText,
                    status,
                    request: { responseURL: config.url }
                };
            }
            addErrorLog(errorInfo);
            return Promise.reject(error);
        });
    }
    request(options) {
        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(), options);
        this.interceptors(instance, options.url);
        return instance(options);
    }
}
export default HttpRequest;



// WEBPACK FOOTER //
// ./src/libs/axios.js